import builder from '../builder';
import MultipleManWoman1 from '../../streamline-icons/light/multiple-man-woman-1.svg';

export default builder('IconMultipleManWoman1Light', MultipleManWoman1);
